import IArchetype from "../Models/IArchetype";

const archetypes: { [id:string] : IArchetype } = {
    "druide": {
        "name": {
            "male": "Druide",
            "female": "Druidesse"
        },
        "skills": [
            {
                "empathy": 2
            },
            {
                "empathy": 2
            },
            {
                "empathy": 3,
                "stamina": 1,
                "medicine": 1,
                "perception": 1
            },
            {
                "empathy": 3,
                "stamina": 1,
                "medicine": 1,
                "perception": 1
            }
        ],
        "hp": [
            0,
            0,
            2,
            2
        ]
    },
    "chasseur": {
        "name": {
            "male": "Chasseur",
            "female": "Chasseuse"
        },
        "skills": [
            {
                "tracking": 2
            },
            {
                "tracking": 2
            },
            {
                "tracking": 3,
                "agility": 1,
                "discretion": 1,
                "strength": 1
            },
            {
                "tracking": 3,
                "agility": 1,
                "discretion": 1,
                "strength": 1
            }
        ],
        "hp": [
            3,
            3,
            5,
            5
        ]
    },
    "roublard": {
        "name": {
            "male": "Roublard",
            "female": "Roublarde"
        },
        "skills": [
            {
                "discretion": 2
            },
            {
                "discretion": 2
            },
            {
                "discretion": 2,
                "intuition": 1,
                "empathy": 1,
                "searching": 1,
                "medicine": 1,
                "perception": 1
            },
            {
                "discretion": 2,
                "intuition": 1,
                "empathy": 1,
                "searching": 1,
                "medicine": 1,
                "perception": 1
            }
        ],
        "hp": [
            0,
            0,
            3,
            3
        ]
    },
    "sorcier": {
        "name": {
            "male": "Sorcier",
            "female": "Sorcière"
        },
        "skills": [
            {
                "intuition": 2
            },
            {
                "intuition": 2
            },
            {
                "intuition": 2,
                "empathy": 1,
                "searching": 1,
                "medicine": 1,
                "perception": 1
            },
            {
                "intuition": 2,
                "empathy": 1,
                "searching": 1,
                "medicine": 1,
                "perception": 1
            }
        ],
        "hp": [
            0,
            0,
            2,
            2
        ]
    },
    "barde": {
        "name": {
            "male": "Barde",
            "female": "Barde"
        },
        "skills": [
            {
                "persuasion": 2
            },
            {
                "persuasion": 2
            },
            {
                "persuasion": 3,
                "agility": 1,
                "empathy": 1,
                "intuition": 1
            },
            {
                "persuasion": 3,
                "agility": 1,
                "empathy": 1,
                "intuition": 1
            }
        ],
        "hp": [
            0,
            0,
            3,
            3
        ]
    },
    "guerrier": {
        "name": {
            "male": "Guerrier",
            "female": "Guerrière"
        },
        "skills": [
            {
                "stamina": 2
            },
            {
                "stamina": 2
            },
            {
                "stamina": 3,
                "strength": 1,
                "intimidation": 1,
                "persuasion": 1
            },
            {
                "stamina": 3,
                "strength": 1,
                "intimidation": 1,
                "persuasion": 1
            }
        ],
        "hp": [
            5,
            5,
            8,
            8
        ]
    }
}

export default archetypes;